module.exports = __webpack_public_path__ + "img/422c6817d7.c6817d7e.png";